import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class Sports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Sports </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      There is a race occurring to see which networks, teams, stadia, 
                      and arenas can be at the forefront of this industry. The possibilities 
                      are endless with immersive technology like virtual and augmented reality. 
                      Through VR you can teleport yourself onto the sideline of a game or put 
                      on a haptic suit and rush outside the pocket trying to avoid a defensive 
                      lineman coming at you. In AR you can scan a team’s logo or brand sponsor 
                      and bring a custom animated message to life. These mediums are advancing 
                      every day allowing us the ability to build the ultimate fan experience. 
                      In the near future, we will purchase products in real-time as we watch live 
                      events through VR. Today, we are becoming smarter as an audience and so we’ve 
                      advanced our appetite. We strive to be closer to the action and in many cases 
                      be apart of it, but we simply can’t. This is the first time in history when 
                      sports technology gives us the edge not only in training, or observation but 
                      also in fan engagement.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      The ways in which we are able to follow sports have evolved over the years. 
                      Radio was the connection between sports and the fans for many years, 
                      especially with baseball. The advent of television added a more powerful 
                      transmission system. Enhancements like color, HD, and large-sized flatscreens 
                      added to the appeal. The internet, cell phones, and IPads have added to the platform. 
                      The next breakthroughs are coming with virtual and augmented reality which will add to the enjoyment.
                      <br></br>
                      Compared to yesterday, entertainment technology and the advancements created for fans to get 
                      the inside scoop has exploded.  A few months later Google revealed Google Cardboard 
                      to start the mobile VR boom.  This led to Fox Sports, ESPN, NBC, CBS, ABC, YouTube TV, 
                      Hulu, Sky Sports and many more outlets allowing users to connect on your TV, cell phone, 
                      iPad, Apple watch and now through virtual reality headsets. Data provided by statista.com has 
                      projected VR revenue for 2018 is $9.1 billion and in the year 2022 $61 billion in XR revenue. 
                      Goldman Sachs has projected that the VR market will outpace the television market in annual revenue by 2025.
                      <br></br>
                      The challenge for virtual reality is to create new ways in which sports can be enjoyed. 
                      Television innovated minicams, skycams, superimposed first down markers and wiring of 
                      coaches are ways to enhance football. The Los Angeles Rams utilized VR technology to allow 
                      potential season ticket buyers to see the unbuilt stadium and sidelines, and what the view 
                      would be from their potential seat location. In our effort to save the Rams back in 1994, 
                      we advocated the construction of a sports town that would have sports-related augmented and 
                      virtual reality rides which would allow the fans to interact with various sports in new and exciting ways.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Check out our ever expanding Sports templates:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Template 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Template 2 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Sports;



// WEBPACK FOOTER //
// ./src/views/Pages/Sports/Sports.js